import { createApp, onMounted } from 'vue';
import { createPinia } from 'pinia';
import TurbolinksAdapter from 'vue-turbolinks';
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';
import AutoComponentesGlobalesVuePlugin from '@/components/global/ComponentesGlobalesVuePlugin';
import CifraVuePlugin from './CifraVuePlugin';

// Función para crear una aplicación Vue con los componentes estandar de Cifra.
// Si se proporciona un store pinia en options, se usa ese, si no, se crea uno nuevo
export function createCifraVueApp(component = {}, props = {}, options = {}) {
  const app = createApp(component, props);

  // Si se proporciona un store personalizado, usarlo; si no, crear uno nuevo
  const pinia = options.store || createPinia();
  app.use(pinia);

  app.use(TurbolinksAdapter)
    .use(CifraVuePlugin)
    .use(AutoComponentesGlobalesVuePlugin);
  return app;
}

/* global Cifra */
export function cargarElementoVueCifra(element) {
  const { loadComponents } = element.dataset;

  const app = createCifraVueApp(
    {
      setup() {
        onMounted(() => {
          // Si se indica que tenemos que cargar componentes, obedecemos
          if (loadComponents) {
            Cifra.App.loadComponents(element);
          }
        });
      },
    },
    {},
  );
  app.mount(element);
  return app;
}

// Tenemos que guardarla como variable porque el plugin de stilus
// y vite la necesita para construir una variable global especial
let stimulusApp;

export function registrarControladores() {
  stimulusApp = Application.start();
  window.Stimulus = stimulusApp;

  const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
  registerControllers(stimulusApp, controllers);
}
